import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import Header from '../../HomePage/Header/Header'
import Footer from '../../HomePage/Footer/Footer'
import HourglassLoader from '../../../Common/HourglassLoader';
import ReCAPTCHA from "react-google-recaptcha";
import FeedbackForm from '../../FeedbackForm/FeedbackForm';

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const OtpVerify = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null);

    const thisemail = location.state?.email;


    let [initialValues, setInitialValues] = useState({

        email: "",
        otp: "",


    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            otp: Yup.string().required("Otp is required.")



        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {
                if (!captchaToken) {
                    setCaptchaError("Please complete the CAPTCHA.");
                    return;
                }
                setSubmitting(true);
                values.email = thisemail
                await axios.post(`${host}/api/web/otp-verify`, {
                    ...values,
                    captchaToken
                })
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success("Otp verified.");
                            resetForm();

                            navigate('/reset-password', { state: { email: thisemail } })

                        } else {
                            if (captchaRef.current) {
                                captchaRef.current.reset(); // Reset the CAPTCHA
                            }
                            setCaptchaToken(null);
                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {
                        if (captchaRef.current) {
                            captchaRef.current.reset(); // Reset the CAPTCHA
                        }
                        setCaptchaToken(null);

                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {

                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);
                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })

    const [timer, setTimer] = useState(() => {
        const savedTime = localStorage.getItem("otpTimer");
        const currentTime = Date.now();
        return savedTime ? Math.max(0, Math.ceil((savedTime - currentTime) / 1000)) : 60;
    });
    const [isTimerCompleted, setIsTimerCompleted] = useState(false);

    useEffect(() => {
        let interval;
        if (timer > 0) {
            setIsTimerCompleted(false);
            interval = setInterval(() => {
                setTimer((prev) => {
                    const newTime = prev - 1;
                    if (newTime <= 0) {
                        clearInterval(interval);
                        localStorage.removeItem("otpTimer");
                    } else {
                        localStorage.setItem("otpTimer", Date.now() + newTime * 1000);
                    }
                    return newTime;
                });
            }, 1000); // Decrease timer every second
        } else {
            setIsTimerCompleted(true);
        }

        // Cleanup interval when the component unmounts
        return () => clearInterval(interval);
    }, [timer]);

    const handleResendOtp = async () => {
        try {
            const value = { email: thisemail };

            const response = await axios.post(`${host}/api/web/resend-otp`, value);

            if (response.status === 200) {
                toast.success("Otp sent to your mail.");
                const resetTime = 60; // Reset timer duration in seconds
                setTimer(resetTime);
                localStorage.setItem("otpTimer", Date.now() + resetTime * 1000);
            } else {
                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);
                toast.error(response.data.message);
            }
        } catch (error) {
            if (captchaRef.current) {
                captchaRef.current.reset(); // Reset the CAPTCHA
            }
            setCaptchaToken(null);
            toast.error("Error submitting form. Please try again.");
        }
    };

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <div>
            <FeedbackForm />
            <Header />
            <div className="login-background">
                {/* <section class="forget-screen-main-secion main-section"> */}
                <div className="login-main-container-two login-main-container">
                    <div className="row login-form-part">
                        <div className="card login-form bg-white">
                            <h3 className="mb-0">Verify Your Otp</h3>
                            <p>Enter otp sent to {thisemail}</p>
                            <form method='post' onSubmit={formik.handleSubmit}>

                                <label htmlFor="" className="label">
                                    {" "}
                                    Otp
                                </label>
                                <input type="text" className='input-form' placeholder="Enter otp" name='otp'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.otp}
                                    maxLength={6}
                                />
                                <div className="help-block with-errors">
                                    {formik.touched.otp && formik.errors.otp ? (
                                        <div className='text-danger'>{formik.errors.otp}</div>
                                    ) : null}
                                </div>
                                <div className="text-end">
                                    {isTimerCompleted ? (
                                        <a onClick={handleResendOtp}>
                                            Resend OTP
                                        </a>
                                    ) : (
                                        <span>Resend OTP in {timer} seconds</span>
                                    )}
                                </div>
                                <div className='mb-2'>
                                    <ReCAPTCHA
                                        sitekey={siteKey}
                                        onChange={handleCaptcha}
                                        ref={captchaRef} // Attach the ref to the CAPTCHA
                                    />
                                    {captchaError && <div className="text-danger">{captchaError}</div>}
                                </div>

                                <button
                                    type="submit"
                                    disabled={formik.isSubmitting}
                                    className="btn btn-primary reset-btn mb-3"
                                >
                                    {formik.isSubmitting ? <HourglassLoader /> : 'Verify Otp'}
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
                {/* </section> */}
            </div>
            <Footer />
        </div>
    )
}

export default OtpVerify